import React from 'react';
import SearchMap from './SearchMap'
import AutoComplete from '../components/AutoComplete';

const SchoolList = ({data}) => {
    return (
        <a className="name" href={`#/schools/${data["Link with ULCS"]}`}>{data["Publication Name"].replace(/ School\s*$/m, '')}
        </a>
    )
}

const SchoolsPage = (props) => {
    var schooltypes = [];
    props.data
    .filter(a => a["Publication Name"] && a["Include in tool"] === "Yes")
    .forEach(function(d) {
        if (d["On Dist web site"] !== "") {
            if (!schooltypes[d["On Dist web site"]])
                schooltypes[d["On Dist web site"]] = [];
            schooltypes[d["On Dist web site"]].push(d);
        }
    });

    return (
        <div>
            <h1>Find a school</h1>
            <p>Find detailed reports on hazards inside Philadelphia classrooms.

            </p><br />

            <div id="inputwrapper">
                <AutoComplete getUrl={props.match} data={props.data} placeholder="Search for a school..." />
            </div>

            <hr/>

            <div className="detailsection" id="bylocation">
                <h2 className="" >Find school by location</h2>
                <div className="legend">
                    <div className="legenditem"><span className="legenddot elementaryschool"></span>Elementary school</div>
                    <div className="legenditem"><span className="legenddot middleschool"></span>Middle school</div>
                    <div className="legenditem"><span className="legenddot highschool"></span>High school</div>
                </div>
                <div className="mapsection" id="allschools">

                    <SearchMap data={props.data}/>
                </div>
            </div>
            <hr/>
            <div className="detailsection" id="bytype">
                <h2 className="" >Find school by type</h2>

                <h3>
                    <span className="outline">Elementary Schools</span>
                </h3>
                <div className="schoolsection">

                    {schooltypes.Elementary.map(school => <SchoolList key={school.Counter} data={school}/>)}
                </div>
                <h3>
                    <span className="outline">Middle Schools</span>
                </h3>
                <div className="schoolsection">

                    {schooltypes.Middle.map(school => <SchoolList key={school.Counter} data={school}/>)}
                </div>
                <h3>
                    <span className="outline">High Schools</span>
                </h3>
                <div className="schoolsection">

                    {schooltypes.High.map(school => <SchoolList key={school.Counter} data={school}/>)}

                </div>

            </div>

        </div>
    )
}

export default SchoolsPage;



// WEBPACK FOOTER //
// ./src/components/SchoolsPage.js